<template>
	<div>
		<!-- 活动须知 -->
		<ss-modal v-model="noticeFlag">
			<div class="signUp-box notice-box">
				<p class="signUp-title">活动须知</p>
				<div class="signUp-row-group">
					<div class="notice-text">{{notice}}</div>
					<div class="notice-btn-group clearfix">
						<button class="btn-primary-hollow btn-radius fr" @click="noticeFlag = false">不同意</button>
						<button class="btn-primary btn-radius fl" @click="signUpFlag = true, noticeFlag = false">同意</button>
					</div>
				</div>
			</div>
		</ss-modal>
		
		<!-- 活动报名 -->
		<ss-modal v-model="signUpFlag">
			<div class="signUp-box">
				<p class="signUp-title">报名资料</p>
				<div class="signUp-row-group">
					<div class="signUp-row clearfix">
						<div class="signUp-row__text"><span class="require-label">*</span>姓名：</div>
						<input class="signUp-row__input" v-model="formData.name" :placeholder="emptyMsgs.name" />
					</div>
					<div class="signUp-row clearfix">
						<div class="signUp-row__text"><span class="require-label">*</span>年龄：</div>
						<input class="signUp-row__input" v-model="formData.age" :placeholder="emptyMsgs.age" />
					</div>
					<div class="signUp-row clearfix">
						<div class="signUp-row__text"><span class="require-label">*</span>身份证号：</div>
						<input class="signUp-row__input" v-model="formData.identityCard" :placeholder="emptyMsgs.identityCard" />
					</div>
					<div class="signUp-row clearfix">
						<div class="signUp-row__text"><span class="require-label">*</span>手机号：</div>
						<input class="signUp-row__input" v-model="formData.mobile" :placeholder="emptyMsgs.mobile" />
					</div>
					<div class="signUp-row clearfix">
						<div class="signUp-row__text">备注：</div>
						<input class="signUp-row__input" v-model="formData.remarks" :placeholder="emptyMsgs.remarks" />
					</div>
					<div class="signUp-btn">
						<button class="btn-primary btn-radius" @click="activityRegister">确认报名</button>
					</div>
				</div>
			</div>
		</ss-modal>
		
		<!-- 报名成功 -->
		<ss-modal v-model="successFlag">
			<div class="signUp-box success-box">
				<p class="signUp-title">恭喜您报名成功！</p>
				<div class="signUp-row-group">
					<p class="success-text">请使用手机查看报名凭证。</p>
					<div class="ewm-box clearfix">
						<div class="ewm-itme">
							<img src="~@/assets/img/main/ewm-android.png" />
							<p class="ewm-text">适用于Android设备</p>
						</div>
            <div class="ewm-itme">
              <img src="~@/assets/img/main/ewm-ios.png" />
              <p class="ewm-text">适用于iOS设备</p>
            </div>
						<div class="ewm-itme">
							<img src="~@/assets/img/main/ewm-wechat-miniapp.jpg" />
							<p class="ewm-text">微信小程序</p>
						</div>
					</div>
				</div>
			</div>
		</ss-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				signUpFlag: false,
				successFlag: false,
				noticeFlag: false,
        notice: "",
				formData: {
					name: '',
					age: '',
					identityCard: '',
					mobile: '',
					remarks: ''
				},
				emptyMsgs: {
					name: '请输入姓名',
					age: '请输入年龄',
					identityCard: '请输入身份证号',
					mobile: '请输入手机号',
					remarks: '填写备注信息'
				}
			}
		},
		props: {
			notice: {
				type: String,
				default: ''
			},
			contentId: {
				type: [String, Number],
				default: ''
			}
		},
		methods: {
			show() {
				if(this.notice){
					this.noticeFlag = true;
				}else{
					this.signUpFlag = true;
				}
			},
			async activityRegister() {
				let isGoing = true;
				for(var key in this.formData){
					if(!this.formData[key] && key !== 'remarks'){
						this.$toast(this.emptyMsgs[key]);
						isGoing = false;
						break;
					}
				}
				if(!isGoing) return ;
        if(!this.validateInput()) return;
				let params = {
					activityId: this.contentId,
					...this.formData
				}
				let res = await this.$http('activityRegister', params);
				res.code === 1 && (this.signUpFlag = false, this.successFlag = true);
			},
      /**
       * 校验报名信息输入格式
       * @returns {boolean} 是否通过校验
       */
      validateInput() {
        console.log(!this.formData.name)
        if(!this.formData.name) {
          this.$toast('姓名不能为空');
          return false;
        }
        if(!this.formData.age || this.formData.age <= 0 || this.formData.age >= 150) {
          this.$toast('年龄必须在0~150之间');
          return false;
        }
        const phoneRegex = /^1[3-9]\d{9}$/;
        if(!phoneRegex.test(this.formData.mobile)) {
          this.$toast('手机号格式不正确');
          return false;
        }
        const idCardRegex = /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
        if (!idCardRegex.test(this.formData.identityCard)) {
          this.$toast('身份证号格式不正确');
          return false;
        }
        return true;
      }
		}
	}
</script>

<style lang="scss">
	// 报名弹窗
	.signUp-box{
		width: 600px;
		// height: 540px;
		padding: 46px 22px 25px;
		border-radius:10px;
		background: #F1F1F1 url(~@/assets/img/culturalActivity/signup-bg.png) center top / 100% auto no-repeat;
		&.notice-box{
			.signUp-row-group{
				padding: 35px 20px 20px;
			}
			.notice-text{
				font-size:24px;
				font-family:Source Han Sans CN;
				font-weight:400;
				color:rgba(51,51,51,.5);
				line-height:44px;
				height: 295px;
				overflow: auto;
        word-break: break-all;
			}
			.notice-btn-group{
				button{
					width:180px;
				}
			}
		}
		&.success-box{
			padding-top: 80px;
			.signUp-row-group{
				margin-top: 25px;
				padding: 60px 44px 38px;
			}
			.success-text{
				font-size:18px;
				font-weight:400;
				color:rgba(72,72,72,1);
				line-height:30px;
				text-align: center;
			}
			.ewm-box{
				margin-top: 47px;
				text-align: center;
				.ewm-itme{
					width: 33%;
					float: left;
					img{
						width:90px;
						height:90px;
					}
					.ewm-text{
						font-size:16px;
						font-weight:400;
						color:rgba(119,119,119,1);
						line-height:30px;
					}
				}
			}
		}
		.signUp-title{
			font-size:45px;
			font-weight:500;
			color:rgba(253,250,249,1);
			text-shadow:0px 9px 10px rgba(113,103,247,0.48);
			text-align: center;
		}
		.signUp-row-group{
			border-radius:10px;
			padding: 36px 80px 36px 76px;
			margin-top: 14px;
			background-color: #fff;
		}
		.signUp-btn{
			width:180px;
			display: block;
			margin: 30px auto 0;
		}
		.signUp-row{
			& + .signUp-row{
				margin-top: 12px;
			}
			.signUp-row__text{
				width: 100px;
				float: left;
				text-align: right;
				font-size:18px;
				font-family:Source Han Sans CN;
				font-weight:400;
				color:rgba(51,51,51,.5);
				line-height:40px;
			}
      .require-label{
        color: #EA2222;
      }
			.signUp-row__input{
				width: 300px;
				float: right;
				height:40px;
				line-height:38px;
				background:rgba(255,255,255,1);
				border:1px solid rgba(211,211,211,1);
				border-radius:5px;
				font-size:18px;
				color:rgba(51,51,51,1);
				padding: 0 14px;
			}
		}
	}
</style>
